import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, MailCheck } from "lucide-react";
import AuthShell from "@/components/auth/AuthShell";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import api, { formatApiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <AuthShell title="Reset your password" subtitle="We'll email you a secure reset link."
      footer={<Link to="/login" className="font-semibold text-primary">Back to sign in</Link>}>
      {sent ? (
        <div className="text-center" data-testid="forgot-success">
          <div className="mx-auto mb-3 w-fit rounded-full bg-success/15 p-3 text-success"><MailCheck className="h-7 w-7" /></div>
          <p className="text-sm text-muted-foreground">If an account exists for <strong>{email}</strong>, a reset link is on its way. It expires in 1 hour.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div>
            <Label htmlFor="f-email">Email</Label>
            <Input id="f-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" data-testid="forgot-email" />
          </div>
          <Button type="submit" className="w-full rounded-full" disabled={busy} data-testid="forgot-submit">
            {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Send reset link
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
